import { useEffect, useRef } from 'react'
import { getStatus } from '@shared/api/httpErrors'
import { checkTelegramAuthToken } from '../api/telegramAuthApi'

const POLL_INTERVAL_MS = 1800

/**
 * Поллит статус токена TG-авторизации с интервалом ~1.8 сек.
 * @param token - Полный токен (telegram_auth_...)
 * @param active - Включён ли поллинг
 * @param onConfirmed - Колбэк когда бэк вернул status=confirmed
 * @param onExpired - Колбэк когда токен истёк/использован (404)
 */
export const useTelegramAuthPolling = (
  token: string | null,
  active: boolean,
  onConfirmed: () => void,
  onExpired: () => void
) => {
  const onConfirmedRef = useRef(onConfirmed)
  const onExpiredRef = useRef(onExpired)
  onConfirmedRef.current = onConfirmed
  onExpiredRef.current = onExpired

  useEffect(() => {
    if (!active || !token) return
    let cancelled = false
    let timer: ReturnType<typeof setTimeout> | null = null

    const tick = async () => {
      if (cancelled) return
      try {
        const res = await checkTelegramAuthToken(token)
        if (cancelled) return
        if (res.status === 'confirmed') {
          onConfirmedRef.current()
          return
        }
      } catch (err) {
        if (cancelled) return
        if (getStatus(err) === 404) {
          onExpiredRef.current()
          return
        }
      }
      timer = setTimeout(tick, POLL_INTERVAL_MS)
    }

    timer = setTimeout(tick, POLL_INTERVAL_MS)
    return () => {
      cancelled = true
      if (timer) clearTimeout(timer)
    }
  }, [token, active])
}
